import { render, staticRenderFns } from "./CountCollectionInLocationPanelContent.vue?vue&type=template&id=71a822a8&"
import script from "./CountCollectionInLocationPanelContent.vue?vue&type=script&lang=js&"
export * from "./CountCollectionInLocationPanelContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports